var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('b-container',{staticClass:"mx-0 px-0",attrs:{"id":"main","fluid":""}},[_c('div',{attrs:{"id":"router-content"}},[_c('router-view')],1),_c('app-header'),_c('app-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }